import React, { useState } from 'react';
import { tagText } from '../../lib/assets';
import axios from 'axios';
import { contractorAuth } from '../../lib/contractorAuth';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * At the top of the device page, whichever tab is open: this device has moved
 * and some things plugged into it are still where they were. The person
 * handling the assets decides, per device, whether each goes with it.
 */
export default function PluggedNotice({ asset, items, onDone }) {
  const pending = (items || []).filter((c) => c.pending);
  const [choice, setChoice] = useState({});
  const [remember, setRemember] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (pending.length === 0) return null;

  const pick = (c) => choice[c.id] || (c.suggest === 'stay' ? 'stay' : 'move');
  const save = async () => {
    setBusy(true);
    setError('');
    try {
      await axios.post(`${API_BASE}/assets/${asset.id}/plugged/decide`, {
        decisions: pending.map((c) => ({ asset_id: c.id, action: pick(c), remember: Boolean(remember[c.id]) }))
      }, contractorAuth());
      await onDone();
    } catch (e) {
      setError(e.response?.data?.error || 'That did not work.');
    }
    setBusy(false);
  };

  return (
    <section className="as-panel" data-testid="plugged-notice" role="group" aria-label="Plugged-in devices to decide">
      <p>{`${tagText(asset)} is at ${asset.location_path || 'a new place'}. These plugged-in devices are still where they were - decide what moves with it:`}</p>
      <ul className="as-attached">
        {pending.map((c) => (
          <li key={c.id} data-testid={`pending-${c.asset_tag}`}>
            <strong>{tagText(c)}</strong>
            {` ${[c.manufacturer, c.model].filter(Boolean).join(' ')} · ${c.location_path || 'no place'}`}
            <span style={{ marginLeft: '0.75rem' }}>
              <label style={{ marginRight: '0.75rem' }}>
                <input type="radio" name={`plug-${c.id}`} checked={pick(c) === 'move'}
                  onChange={() => setChoice({ ...choice, [c.id]: 'move' })} />{' Moves with it'}
              </label>
              <label style={{ marginRight: '0.75rem' }}>
                <input type="radio" name={`plug-${c.id}`} checked={pick(c) === 'stay'}
                  onChange={() => setChoice({ ...choice, [c.id]: 'stay' })} />{' Stays where it is'}
              </label>
              <label>
                <input type="checkbox" checked={Boolean(remember[c.id])}
                  onChange={(e) => setRemember({ ...remember, [c.id]: e.target.checked })} />{' Remember for this device'}
              </label>
            </span>
          </li>
        ))}
      </ul>
      {error && <p className="as-error" role="alert">{error}</p>}
      <button type="button" className="btn btn-primary" disabled={busy} onClick={save}>Save</button>
    </section>
  );
}
